// Retain an uncertain request across dialog close/reopen and page reload. A new
// payload is blocked until the previous attempt has been resolved by replay.
const memory = new Map();
const storageKey = (user, endpoint, target = "") =>
  `almox_pending:${JSON.stringify([user?.tenant_id, user?.id, endpoint, target])}`;

export function pendingRequest(user, endpoint, target = "") {
  const slot = storageKey(user, endpoint, target);
  if (memory.has(slot)) return memory.get(slot);
  try {
    const saved = JSON.parse(sessionStorage.getItem(slot) || "null");
    if (saved?.key && saved?.payload) { memory.set(slot, saved); return saved; }
  } catch { /* sessionStorage can be disabled; memory still protects retries. */ }
  return null;
}

export function beginRequest(user, endpoint, payload, target = "") {
  const slot = storageKey(user, endpoint, target);
  const pending = pendingRequest(user, endpoint, target);
  const serialized = JSON.stringify(payload);
  if (pending) {
    if (JSON.stringify(pending.payload) !== serialized) {
      throw new Error("Há uma operação sem confirmação. Repita os mesmos dados antes de iniciar outra operação.");
    }
    return pending;
  }
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  const request = { key: Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join(""), payload: JSON.parse(serialized) };
  memory.set(slot, request);
  try { sessionStorage.setItem(slot, JSON.stringify(request)); } catch { /* See above. */ }
  return request;
}

export function finishRequest(user, endpoint, target = "") {
  const slot = storageKey(user, endpoint, target);
  memory.delete(slot);
  try { sessionStorage.removeItem(slot); } catch { /* See above. */ }
}

export function rejectedRequest(error) {
  // These responses definitively reject before commit. A timeout/5xx is unknown.
  // Authentication/authorization failures happen before receipt lookup; an
  // earlier uncertain attempt can still have committed before access expired.
  return [400, 404, 409, 422].includes(error?.response?.status);
}
